export const themeColor = {
  primary: "#f03975",
  sub: "#f8d00f",
  white: "#fff",
};
